/* eslint-disable no-console */
import { toast } from '@fabric-ds/elements';
import { getDataContext } from 'common/lib/helpers/DataContext';

export const get = (URL, response, error) => {
    URL = fixUrl(URL);
    const fetchPromise = fetch(URL, {
        headers: getAuthHeaders(),
        credentials: 'include',
    });
    handleRequest(fetchPromise, response, error);
};

export const getWithHeaders = (URL, headers, response, error, failSilently) => {
    const fetchPromise = fetch(URL, {
        headers,
        credentials: 'include',
    });
    handleRequest(fetchPromise, response, error, failSilently);
};

export const getWithoutHeaders = (URL, response, error) => {
    const fetchPromise = fetch(URL);
    handleRequest(fetchPromise, response, error);
};

export const post = (URL, body, response, error) => {
    URL = fixUrl(URL);

    const fetchPromise = fetch(URL, {
        method: 'POST',
        body,
        headers: getAuthHeaders(),
        credentials: 'include',
    });
    handleRequest(fetchPromise, response, error);
};

export const put = (URL, body, response, error) => {
    URL = fixUrl(URL);

    const fetchPromise = fetch(URL, {
        method: 'PUT',
        body,
        headers: getAuthHeaders(),
        credentials: 'include',
    });
    handleRequest(fetchPromise, response, error);
};

export const deleteRequest = (URL, response, error) => {
    URL = fixUrl(URL);
    const fetchPromise = fetch(URL, {
        method: 'DELETE',
        headers: getAuthHeaders(),
        credentials: 'include',
    });
    handleRequest(fetchPromise, response, error);
};

export const download = (URL, response, error) => {
    URL = fixUrl(URL);
    const fetchPromise = fetch(URL, {
        headers: getAuthHeaders(),
    });
    handleRequestDownload(fetchPromise, response, error);
};

export const upload = (URL, body, response, error) => {
    URL = fixUrl(URL);
    const headers = getAuthHeaders();
    delete headers['Content-Type'];

    const fetchPromise = fetch(URL, {
        method: 'POST',
        body,
        headers,
        credentials: 'include',
    });
    handleRequest(fetchPromise, response, error);
};

const handleRequest = (fetchPromise, response, error, failSilently) => {
    fetchPromise
        .then(function (res) {
            if (res.ok) res.json().then(data => response(data));
            else if (error) res.json().then(data => error(data));
            else throw Error(res.status);
        })
        .catch(function (err) {
            if (!failSilently) {
                console.error(`REST fallback (${err.toString()})`);
                fallbackWithToast();
            }
        });
};

const fixUrl = function (URL) {
    const { orgId } = document.getElementById('ad-data');
    if (orgId) {
        const separator = URL.includes('?') ? '&' : '?';
        return `${URL + separator}orgId=${orgId}`;
    }
    return URL;
};

const handleRequestDownload = (fetchPromise, response, error, fallback) => {
    fetchPromise
        .then(res => {
            if (res.ok) return res;

            res.text().then(d => error(d));
            throw Error(res.status);
        })
        .then(d => d.text())
        .then(d => response(d))
        .catch(function (err) {
            if (fallback) fallback();
            console.error(`REST ${err.toString()}`);
        });
};

const getAuthHeaders = () => {
    const headers = { 'Content-Type': 'application/json' };
    const { orgId, userId } = getDataContext('ad-data');

    headers.AuthOrgId = orgId || 0;
    headers.AuthLoginId = userId;
    return headers;
};

const fallbackWithToast = () => {
    const msg = 'Ooops! Noe gikk galt. Vennligst prøv igjen eller kontakt FINN Kundesenter';

    const config = {
        type: 'error',
        duration: 30000,
    };
    try {
        toast(msg, config);
    } catch (err) {
        console.error(err);
    }
};
